import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => {
	return {
		dialogContainer: {
			maxWidth: "600px"
		},
		dialogPaper: {
			width           : "100%",
			margin          : "20px",
			backgroundColor : theme.colors.body.primary,
			color           : theme.colors.text.primary
		},
		dialogTextStyles: {
			color: theme.colors.text.primary
		}
	};
} );